import { Bounce, toast } from "react-toastify";
import Mensagens from "./MensagemUtils";

const configuracao = {
    position: "top-center",
    autoClose: 1500,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
    progress: undefined,
}

const NotificacaoUtils = {
    sucesso: (mensagem, opcoes = {}) => {
        toast.success(mensagem, { ...configuracao, ...opcoes });
    },
    erro: (mensagem, opcoes = {}) => {
        toast.error(mensagem, { ...configuracao, ...opcoes });
    },
    aviso: (mensagem, opcoes = {}) => {
        toast.warn(mensagem, { ...configuracao, ...opcoes });
    },
    info: (mensagem, opcoes = {}) => {
        toast.info(mensagem, { ...configuracao, ...opcoes });
    },
    emDesenvolvimento: () => {
        toast(Mensagens.FUNCIONALIDADE_EM_DESENVOLVIMENTO, {
          position: "top-center",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          transition: Bounce,
        });
    },
    promise: (promise, loadingMessage, sucessMessage, errorMessage, opcoes = {}) => {
        let toastPromise = toast.promise(promise, {
            pending: loadingMessage,
            success: sucessMessage,
            error: errorMessage,
        }, {
            ...configuracao,
            ...opcoes,
        });

        return toastPromise;
    }
};
 
export default NotificacaoUtils;